<template>
    <ul
        ref="scrollList"
        class="border-t border-gray scroll-smooth"
    >
        <accordion-list-item
            v-for="group in visibleGroups"
            :key="group.code"
            :item-data="group"
            @scrollToTop="scrollToTop"
        />
    </ul>
</template>

<script>
    import AccordionListItem from './AccordionListItem.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            AccordionListItem,
        },

        computed: {
            visibleGroups() {
                return this.customizerStore.visibleGroups;
            },
        },

        methods: {
            scrollToTop() {
                this.$refs.scrollList.scrollTo(0, 0);
            },
        },
    };
</script>
